export const isValidDateTime = (incidentDateTime: string) => {
  try {
    const [date, time] = incidentDateTime.split(' ');
    const newDate = parseDateTime(date, time);
    return !Number.isNaN(newDate);
  } catch (e: any) {
    // alert(`Exception validating dateTime: ${e.message}`);
    return false;
  }
};

// This is to work around Date.parse not supporting the format we want
// in an older versions of safari. And indeed it's not required by the spec to support that format.
export const parseDateTime = (dateString: string, timeString: string) => {
  try {
    const dateParts = dateString.split('-').map((n: string) => parseInt(n, 10));
    const timeParts = timeString.split(':').map((n: string) => parseInt(n, 10));

    if (dateParts[1]) dateParts[1] -= 1; // months in new Date() are 0 based
    const allParts = dateParts.concat(timeParts);
    const newDate = new Date(...(allParts as []));
    return newDate;
  } catch (e: any) {
    console.log('Exception parsing dateTime', e);
    return false;
  }
};
